import { useAtom, useAtomValue } from "jotai"
import { filterAtom } from "../atoms/filters"

export const useFilterAtom = () => useAtom(filterAtom)

export const useFilterAtomValue = () => useAtomValue(filterAtom)
